import * as yup from "yup";
import { emailRegEx } from "./RegEx";

export const becomeDealerSchema = yup.object().shape({
  firstName: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("First name is required"),
  lastName: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Last name is required"),
  companyName: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Email is required"),
  email: yup
    .string()
    .matches(emailRegEx, "Should be valid email")
    .required("Email is required"),
  streetAddress: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Adress is required"),
  city: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("City is required"),
  zipCode: yup
    .string()
    .trim()
    .min(3, 'Zip code must be at least 3 characters long.')
    .max(10, 'Zip code must be no more than 10 characters long.')
    .required("ZIP code is required"),
  idCountry: yup.number().required("Country is required"),
  idState: yup.number(),
  phoneNumber: yup
    .string()
    .required("Phone is required'")
    .trim()
    .min(12, "Must be at least 12 char")
    .max(17, "Must be at most 17 char"),
  username: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Username is required"),
  password: yup
    .string()
    .min(6, "Must be at least 6 char")
    .max(18, "Must be at most 18 char")
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .min(6, "Must be at least 6 char")
    .max(18, "Must be at most 18 char")
    .required("Retype password is required")
    .oneOf([yup.ref('password')], 'Your passwords do not match.'),
  partnerOption : yup.number(),
});
